import { render, staticRenderFns } from "./ProductsV2.vue?vue&type=template&id=77319c62"
import script from "./ProductsV2.vue?vue&type=script&lang=js"
export * from "./ProductsV2.vue?vue&type=script&lang=js"
import style0 from "./ProductsV2.vue?vue&type=style&index=0&id=77319c62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports